// @flow
import { createSelector } from 'reselect';
import { MOUNT_POINT } from './constants';
import type { State, Form } from './reducer';
import type { State as WFState } from '../reducer';
import getWorkflowState from '../selectors';

export const getFormState: (state: WFState) => State = createSelector(getWorkflowState, (state) => state[MOUNT_POINT]);

export const getFormCode = (state: State, code: string, executionId: string): string => code;

export const getForm: (state: State, code: string, executionId: string) => Form = createSelector(
    [getFormState, getFormCode],
    (state, code) => state[code],
);

export const getModalForms: (state: State) => Array<Form> = createSelector(
    getWorkflowState, (state) => (
        Object.entries(state[MOUNT_POINT])
            .filter(([code, form]) => (form.modal))
            .map(([code, form]) => { form.code = code; return form; })
    ),
);
